import classnames from 'classnames';
import { Menu } from "../Menu/Menu";
import styles from "./PrimaryMenuSubNav.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var PrimaryMenuSubNav = function PrimaryMenuSubNav(_ref) {
  var primaryMenuSubNavItems = _ref.primaryMenuSubNavItems,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? '' : _ref$style,
    _ref$styleText = _ref.styleText,
    styleText = _ref$styleText === void 0 ? '' : _ref$styleText;
  return /*#__PURE__*/_jsx(Menu, {
    style: classnames(styles.subnavMenu, style),
    styleText: classnames(styles.subnavMenuText, styleText),
    menuItems: primaryMenuSubNavItems
  });
};